'use client';

import React from 'react';
import VerificationForm from './VerificationForm';
import OemCustomizationForm from './OemCustomizationForm';

const CustomizationForm = () => {
  return (
    <div
      id="customization"
      className="flex flex-col"
      data-testid="customization-form"
    >
      <VerificationForm />
      <OemCustomizationForm />
    </div>
  );
};

export default CustomizationForm;
